import React from 'react';

export const EqCountryModal = {
  title: 'Country',
  body: (
    <div>
      <p>
        The country where the earthquake effects were observed.
      </p>
    </div>
  ),
};
